import { faTachometerAlt } from "@fortawesome/free-solid-svg-icons";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons/faCaretDown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Anchor,
  Avatar,
  Box,
  Group,
  Menu,
  Text,
  UnstyledButton
} from "@mantine/core";
import * as React from "react";
import { Link, useNavigate } from "react-router-dom";
import pjson from "../../../package.json";
import { ImageSize } from "../../types/image/image";
import { Role } from "../../types/persons/Role";
import { IPersonUpdate } from "../../types/persons/person";
import { Privilege } from "../../types/persons/privilege";
import { getPersonAvatarLink } from "../person/PersonAvatar";
import { PersonLink } from "./Links";
import EmailVerifiedPrompt from "./person/EmailVerifiedPrompt";

interface HeaderProps {
  role: Role;
  person: IPersonUpdate;
  logout: () => Promise<null>;
  privilege?: Privilege;
}

const Header: React.FunctionComponent<HeaderProps> = ({
  logout,
  person,
  privilege,
  role,
}) => {
  // Using Mantine Menu component handles its own state
  const navigate = useNavigate();

  const showAdminView = !!(privilege && (Privilege.hasPrivilege(privilege, Privilege.manager) || person.admin || Role.hasRole(role, Role.supervisor)));

  return (
    <Box
      h={60}
      px="md"
      style={{
        backgroundColor: "#212529",
        borderBottom: "1px solid #454d55",
      }}
    >
      <Group h="100%" justify="space-between">
        <Anchor
          component={Link}
          to="/"
          style={{
            color: "white",
            textDecoration: "none",
            fontSize: "1rem",
            fontWeight: "bold",
          }}
          className="logo"
        >
          Stadium Supervisor
        </Anchor>
        <Group gap="md">
          {/* Admin Dashboard Link */}
          {showAdminView && (
            <Anchor
              component={Link}
              to="/admin"
              style={{
                color: "white",
                textDecoration: "none",
                padding: "8px 12px",
                borderRadius: "4px",
                marginRight: "5px",
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                transition: "background-color 0.2s",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.2)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.1)";
              }}
            >
              <FontAwesomeIcon icon={faTachometerAlt} />
              <Box 
                component="span" 
                visibleFrom="sm"
                style={{ marginLeft: "8px" }}
              >
                Admin
              </Box>
            </Anchor>
          )}

          {/* {Role.hasRole(role, Role.administrative) && <>
          <Navlink link="https://docs.stadiumsupervisor.com.au" text="Documentation" />
        </>} */}

          <PersonLink
            identifier={person.externalIdentifier}
            style={{
              color: "white",
              textDecoration: "none",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Group gap="xs">
              <Avatar
                size={30}
                radius="xl"
                src={getPersonAvatarLink(person.image, ImageSize.small)}
              />
              <Text fw={700} c="white" visibleFrom="sm">
                {person.preferredName || person.firstName}
              </Text>
            </Group>
          </PersonLink>

          <Box
            visibleFrom="sm"
            style={{
              borderRight: "1px solid #45484a",
              height: "30px",
              marginLeft: "10px",
              marginRight: "10px",
            }}
          />

          <Menu shadow="md" width={200}>
            <Menu.Target>
              <UnstyledButton
                style={{
                  border: "none",
                  background: "none",
                  color: "#5c656e",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <EmailVerifiedPrompt />
                <FontAwesomeIcon style={{ marginLeft: "5px" }} icon={faCaretDown} />
              </UnstyledButton>
            </Menu.Target>

            <Menu.Dropdown>
              <Menu.Label>
                <Text fw={700}>{person.fullName}</Text>
                <Text size="sm" c="dimmed" mt={2}>
                  {person.externalIdentifier}
                </Text>
              </Menu.Label>

              <Menu.Divider />

              <Menu.Item onClick={() => navigate("/settings")}>
                Settings
              </Menu.Item>

              <Menu.Item onClick={() => logout().catch((er) => alert(er))}>
                Logout
              </Menu.Item>

              {pjson?.version && (
                <Menu.Label>
                  Version v{pjson.version}
                </Menu.Label>
              )}
            </Menu.Dropdown>
          </Menu>
        </Group>
      </Group>
    </Box>
  );
};

export default Header;
